import { render } from "./TheHeaderNaviOfUserMenu.vue?vue&type=template&id=34610b5d&scoped=true&ts=true"
import script from "./TheHeaderNaviOfUserMenu.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviOfUserMenu.vue?vue&type=script&lang=ts"

import "./TheHeaderNaviOfUserMenu.vue?vue&type=style&index=0&id=34610b5d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34610b5d"]])

export default __exports__